// extracted by mini-css-extract-plugin
module.exports = {"input":"FieldCurrencyInput_input__IHos2","inputSuccess":"FieldCurrencyInput_inputSuccess__17otL","inputError":"FieldCurrencyInput_inputError__1rbDS"};